module.exports = __webpack_public_path__ + "static/img/znsb_img_wxqybj.5662c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/znsb_img_wxqybj.png
// module id = Yw5i
// module chunks = 21